import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  ul: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    listStyleType: "none",
    maxWidth: "976px",
    maxHeight: "85px",
    ...shorthands.overflow("hidden"),
    ...shorthands.gap("32px"),
    ...shorthands.margin("0px", "auto"),
    ...shorthands.padding("1px", "0px", "0px", "0px"),

    "& li": {
      display: "list-item",
    },
  },

  ulExpanded: {
    maxHeight: "unset",
    ...shorthands.overflow("visible"),
  },
});
